import React, { FC } from "react";

import "./styles.scss";

export const Line: FC = () => {
  return <hr className="ams-plan-line" />;
};
